import {useContext, useEffect, useState} from "react";
import {Form} from "react-bootstrap";
import {ReactComponent as AttachIcon} from "../../asset/icons/attachIcon.svg";
import {COMPANY_BUSINESS_TYPE_TREE, COMPANY_DETAIL} from "../../helperData/ApiAddress";
import {get, patch, post} from "../../controlers/global/ConfigRequest";
import UserPic from "../../asset/icons/accountIcon.svg";
import {ToastContext} from "../../component/global/ToastContext";
import TreeSearchSelect from "../../component/global/TreeSearchSelect";
import {ReactComponent as TrashIcon} from "../../asset/icons/trash.svg";
import Spinner from "react-bootstrap/Spinner";
import IconBox from "../../component/global/IconBox";
import {ReactComponent as EditIonDark} from "../../asset/icons/editIconDark.svg";
import {useTranslation} from "react-i18next";
import {buildCompanyProfilePayload, selectedBusinessTypeIds} from "./companyProfilePayload";

export default function GeneralInfo(props) {
  const {
    form,
    setForm,
    disable,
    companyList,
    setCompanyList,
    mode,
    auth,
  } = props

  const show = useContext(ToastContext);
  const [loading, setLoading] = useState(false);
  const [deleteMode, setDeleteMode] = useState(false);
  const [itemLoader, setItemLoader] = useState();
  const [title, setTitle] = useState("");
  const [translates, setTranslates] = useState("");
  const [language, setLanguage] = useState("en");
  const [translateMode, setTranslateMode] = useState("");
  const [translateId, setTranslateId] = useState();
  const [titleErr, setTitleErr] = useState("");
  const [languageErr, setLanguageErr] = useState("");
  const {t, i18n} = useTranslation();
  const [businessTypeTree, setBusinessTypeTree] = useState([]);

  useEffect(() => {
    setTranslates(form.translates);
  }, [form.translates]);

  useEffect(() => {
    get(COMPANY_BUSINESS_TYPE_TREE, { language: i18n.language || "fa" })
      .then((tree) => setBusinessTypeTree(Array.isArray(tree) ? tree : []))
      .catch(() => setBusinessTypeTree([]));
  }, [i18n.language]);

  const deleteTranslate = (id) => {
    setTranslates(translates.filter((item) => item.id !== id));
  };

  const handleFormErr = () => {
    if (title === "") {
      setTitleErr(t("Src.Pages.Profile.GeneralInfo.setTitleErr"));
    } else {
      setTitleErr();
    }
    if (language === "") {
      setLanguageErr(t("Src.Pages.Profile.GeneralInfo.setLanguageErr"));
    } else {
      setLanguageErr();
    }

    if (title !== "" && language !== "") {
      return false;
    }

    return true;
  };

  const saveForm = (e) => {
    setLoading(true);
    e.preventDefault();
    const sendingForm = buildCompanyProfilePayload(form, translates);
    if (mode === "new") {
      post(COMPANY_DETAIL.replace("{id}/", ""), sendingForm)
        .then((r) => {
          setForm(r);
          if (auth.usertype === 1) {
            const clonedResult = Object.assign(
              [],
              companyList.results
            );
            clonedResult.push(r);
            setCompanyList({
              ...companyList,
              results: clonedResult,
            });
          }
          setLoading(false);
          setForm({
            name: "",
            logo: null,
            web_url: "",
            phone_number: "",
            email: "",
            contract_number: "",
            address: "",
            translates: [],
            category: null,
            business_types: [],
          });
        })
        .catch((r) => {
          setLoading(false);
          let timer = 10;
          for (let i in r.response.data) {
            timer += 100;
            setTimeout(
              () => show(r.response.data[i], "danger"),
              timer
            );
          }
        });
    } else {
      patch(COMPANY_DETAIL.replace("{id}", form.id), sendingForm)
        .then((r) => {
          setForm(r);
          if (auth.usertype === 1) {
            const clonedResult = Object.assign(
              [],
              companyList.results
            );
            for (let i = 0; i < clonedResult.length; i++) {
              if (clonedResult[i].id === form.id) {
                clonedResult[i] = r;
                break;
              }
            }
            setCompanyList({
              ...companyList,
              results: clonedResult,
            });
          }
          setLoading(false);
        })
        .catch((r) => {
          setLoading(false);
          show(
            t("Src.Pages.Profile.GeneralInfo.Lang.Danger.Err"),
            "danger"
          );
        });
    }
  };

  const editTranslate = (id) => {
    setTranslateMode("edit");
    setTranslateId(id);
    setTitle(translates.filter((item) => item.id === id)[0]?.name);
    setLanguage(translates.filter((item) => item.id === id)[0]?.language);
  };

  const addTranslate = () => {
    let hasErr = handleFormErr();
    if (hasErr === false) {
      if (translateMode === "edit") {
        let editDataId = translates.findIndex(
          (item) => item.id === translateId
        );
        translates[editDataId].name = title;
        translates[editDataId].language = language;
        setTranslateMode("");
        setTitle("");
        setLanguage("");
      } else {
        setTranslates([
          ...translates,
          {
            name: title,
            language,
            id: Math.floor(Math.random(100 * 10)),
          },
        ]);
      }
    }
  };

  const formHandle = (e, key) => {
    setForm({...form, [key]: e.target.value});
  };

  const businessTypeHandle = (ids) => {
    const next = Array.isArray(ids) ? ids : [];
    setForm({
      ...form,
      business_types: next,
      category: next[0] ?? null,
    });
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      // convert file to base64;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const getFileHandle = async (e) => {
    // push files to relative file array;

    let file = e.currentTarget.files[0];
    let file64 = await toBase64(file);
    setForm({...form, logo: file64});
  };

  return (
    <>
      <div className="page-load-fade">
        <form className="general-info-form">
          <Form.Group controlId="formName">
            <Form.Label>
              {t(
                "Organizational.Profile.OrganizationalName.Label"
              )}
            </Form.Label>
            <Form.Control
              type="text"
              placeholder={t(
                "Organizational.Profile.Hint.OrganizationalName.Label"
              )}
              value={form.name}
              onChange={(e) => formHandle(e, "name")}
            />
          </Form.Group>
          <Form.Group controlId="business-types" className="business-type-field">
            <Form.Label>
              {t("Organizational.Profile.BusinessType.label")}
            </Form.Label>
            <TreeSearchSelect
              data={businessTypeTree}
              multiple
              className="business-type-select"
              placeholder={t(
                "Organizational.Profile.BusinessType.placeholder"
              )}
              value={selectedBusinessTypeIds(form)}
              onChange={businessTypeHandle}
            />
            <p className="field-hint">
              {t("Organizational.Profile.BusinessType.hint")}
            </p>
          </Form.Group>

          <Form.Group controlId="usersite">
            <Form.Label>
              {t("Organizational.Profile.Website.Label")}
            </Form.Label>
            <Form.Control
              type="url"
              placeholder={t(
                "Organizational.Profile.Hint.Website.Label"
              )}
              value={form.web_url || ""}
              onChange={(e) => formHandle(e, "web_url")}
            />
          </Form.Group>
          <Form.Group controlId="usertel">
            <Form.Label>
              {t("Organizational.Profile.Telephone.Label")}
            </Form.Label>
            <Form.Control
              type="tel"
              placeholder={t(
                "Organizational.Profile.Hint.Telephone.Label"
              )}
              dir="ltr"
              style={{textAlign: "right"}}
              value={form.phone_number || ""}
              onChange={(e) => formHandle(e, "phone_number")}
            />
          </Form.Group>
          <Form.Group controlId="useremail">
            <Form.Label>
              {t("Organizational.Profile.EmailAddress.Label")}
            </Form.Label>
            <Form.Control
              type="email"
              placeholder={t(
                "Organizational.Profile.Hint.EmailAddress.Label"
              )}
              value={form.email || ""}
              onChange={(e) => formHandle(e, "email")}
            />
          </Form.Group>
          <Form.Group controlId="contractno">
            <Form.Label>
              {t("Organizational.Profile.ContractNumber.Label")}
            </Form.Label>
            <Form.Control
              type="email"
              placeholder={t(
                "Organizational.Profile.Hint.ContractNumber.Label"
              )}
              value={form.contract_number || ""}
              onChange={(e) => formHandle(e, "contract_number")}
            />
          </Form.Group>

          <Form.Group controlId="logo" className="form_group_badge">
            <div>
              <Form.Label>
                {t("Organizational.Profile.LogoPicture.Label")}
              </Form.Label>
              <Form.Label htmlFor="upload-profile-picture">
                <div className="input-like-div">
                  <p>
                    {t(
                      "Organizational.Profile.LogoPicture.Hint.Label"
                    )}
                  </p>
                  <div
                    className="button-like-div"
                    onClick={(e) => e.preventDefault()}
                  >
                    <AttachIcon/>
                  </div>
                </div>
                <input
                  type="file"
                  onChange={getFileHandle}
                  accept="image/*"
                  id="upload-profile-picture"
                  name="upload-profile-picture"
                />
              </Form.Label>
            </div>
            <div
              id="profile-picture"
              style={{
                backgroundImage: `url(${form.logo || UserPic})`,
              }}
            ></div>
          </Form.Group>
          <Form.Group controlId="address">
            <Form.Label>
              {t("Organizational.Profile.Address.Label")}
            </Form.Label>
            <Form.Control
              as="textarea"
              placeholder={t(
                "Organizational.Profile.Hint.Address.Label"
              )}
              style={{height: "100px"}}
              value={form.address || ""}
              onChange={(e) => formHandle(e, "address")}
            />
          </Form.Group>
          <div className="add-lang-company-profile">
            <div className="select-box-add-ln">
              <label>
                {t("Organizational.Profile.Title.Label")}
              </label>
              <input
                name="title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                style={
                  titleErr ? {border: "1px solid red"} : {}
                }
              />
            </div>
            <div className="select-box-add-ln">
              <label>
                {t("Organizational.Profile.Language.Label")}
              </label>
              <select
                onChange={(e) => setLanguage(e.target.value)}
                value={language}
              >
                <option value="en">
                  {t(
                    "Organizational.Profile.Language.English.Select"
                  )}
                </option>
                <option value="ar">
                  {t(
                    "Organizational.Profile.Language.Arabic.Select"
                  )}
                </option>
              </select>
            </div>
            <IconBox
              clickFunction={addTranslate}
              iconName={
                translateMode === "edit"
                  ? "editIconBlue"
                  : "plusIconLarge"
              }
              specialClass="blue_border_box"
            />
          </div>
        </form>
      </div>
      <div>
        {translates?.length > 0 &&
          (loading ? (
            <div className="loading"></div>
          ) : (
            <div className={"table-container "}>
              <table className="user-table company-profile-table">
                <thead>
                <tr className="header-row">
                  <th>
                    {t(
                      "Organizational.Profile.RowNumber.Label"
                    )}
                  </th>
                  <th>
                    {t(
                      "Organizational.Profile.Title.Label"
                    )}
                  </th>
                  <th>
                    {t(
                      "Organizational.Profile.Father.Label"
                    )}
                  </th>
                  <th>
                    {t(
                      "Organizational.Profile.Language.Label"
                    )}
                  </th>
                  <th className="edit-delete-th">
                    {t(
                      "Organizational.Profile.Function.Label"
                    )}
                  </th>
                </tr>
                </thead>
                <tbody>
                {translates ? (
                  translates?.map((item, index) => (
                    <tr
                      key={index}
                      className={
                        "profile-translate-table " +
                        (deleteMode &&
                        itemLoader === item.id
                          ? "delete-filter"
                          : "")
                      }
                    >
                      <td className="index-title">
                        <div className="level">
                          {index + 1}
                        </div>
                      </td>
                      <td className="user">
                        <div>
                          <div>{item.name}</div>
                        </div>
                      </td>
                      <td>-</td>
                      <td>{item.language}</td>
                      <td className="edit-btns">
                        <button
                          onClick={() =>
                            deleteTranslate(
                              item.id
                            )
                          }
                        >
                          <TrashIcon/>
                        </button>
                        <button
                          onClick={() =>
                            editTranslate(
                              item.id
                            )
                          }
                        >
                          <EditIonDark/>
                        </button>
                        {/* <button onClick={() => deleteOrder(item.id)}>
                                    <TrashIcon />
                                  </button> */}
                      </td>
                      {deleteMode &&
                        itemLoader === item.id && (
                          <div className="delete-spiner">
                            <Spinner
                              animation="border"
                              role="status"
                            >
                              <span className="visually-hidden"></span>
                            </Spinner>
                          </div>
                        )}
                    </tr>
                  ))
                ) : (
                  <div>
                    {t(
                      "Organizational.Profile.Not.Found"
                    )}
                  </div>
                )}
                </tbody>
              </table>
            </div>
          ))}
      </div>
      <div className="btn-group company-profile-btn">
        <button
          className=" blue"
          disabled={disable || loading}
          onClick={saveForm}
        >
          {loading ? (
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          ) : mode === "new" ? (
            <div>
              {t("Organizational.Profile.Add.Organization")}
            </div>
          ) : (
            <div>
              {t(
                "Organizational.Profile.EditOrganizational.Button"
              )}
            </div>
          )}
        </button>
      </div>
    </>
  );
}
